import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { history } from 'nallian-shared-ui/lib/config/history';
import createPrincipalService from '../../services/principals/createPrincipalService';
import PrincipalForm from './PrincipalForm';
import { TABS } from '../../constants';
import { mapPrincipalCommunityApps } from '../../helpers/principals/mapPrincipalCommunityApps';

const EMPTY_PRINCIPAL = {
  inviteRequest: {
    invitationType: 1, // temporary fixed (1 email), will later come from api
    sendInvitation: true,
  },
};

const NewPrincipal = ({
  organisationId,
  urlRoot,
  open,
  dispatchCreatePrincipalPost,
  createPrincipalFetch,
  isOrgAdmin,
}) => {
  const { t } = useTranslation();

  const handleSubmit = useCallback(
    body =>
      dispatchCreatePrincipalPost(
        {
          ...body,
          organisation: { id: organisationId },
          communityApps: mapPrincipalCommunityApps(body.communityApps),
        },
        () => history.push(`${urlRoot}/${TABS.PRINCIPALS}`),
        t
      ),
    [urlRoot, organisationId, dispatchCreatePrincipalPost, t]
  );

  if (!open) return null;

  return (
    <PrincipalForm
      header={t('newUser')}
      onSubmit={handleSubmit}
      submitProcessing={createPrincipalFetch.pending}
      returnRoute={`${urlRoot}/${TABS.PRINCIPALS}`}
      cancelRoute={`${urlRoot}/${TABS.PRINCIPALS}`}
      data={EMPTY_PRINCIPAL}
      organisationId={organisationId}
      prefillLocalFields={isOrgAdmin}
    />
  );
};

NewPrincipal.propTypes = {
  organisationId: PropTypes.string.isRequired,
  urlRoot: PropTypes.string.isRequired,
  dispatchCreatePrincipalPost: PropTypes.func.isRequired,
  createPrincipalFetch: PropTypes.object.isRequired,
  isOrgAdmin: PropTypes.bool.isRequired,
  open: PropTypes.bool,
};

NewPrincipal.defaultProps = { open: false };

export default createPrincipalService(NewPrincipal);
